module.exports = __webpack_public_path__ + "img/H1.908df386.png";